<main class="agpr-report">
    <div class="agpr-report-container">
        <h2 class="u-srOnly">{{ 'Reports.pageHeading' | localize: {name: report.name} }}</h2>
        <section
            class="agpr-report-primaryWorkflow"
            [attr.aria-label]="'Common.layout.main' | localize"
        >
            <div
                *ngIf="!titleEditing"
                class="agpr-report-title"
                [ngClass]="{'agpr-report-title--empty': !report.title}"
            >
                {{ report.title ? report.title : ('Reports.untitled' | localize) }}
                <agpr-button
                    id="editReportTitleButton"
                    [style]="buttonTypes.icon"
                    icon="fa-regular fa-duotone fa-pen"
                    tooltip="Reports.editTitle"
                    (click)="selectEditTitleField()"
                ></agpr-button>
            </div>
            <agpr-text-input
                *ngIf="titleEditing"
                class="agpr-report-title agpr-report-title--input"
                [maxLength]="64"
                [bottomMargin]="false"
                [initialFocus]="true"
                [(ngModel)]="report.title"
                [initialHighlight]="true"
                (blur)="titleEditing=false"
                (keydown)="keyDown($event)"
            >
            </agpr-text-input>
            <div
                class='agpr-report-contents'
                [agprLoading]="saveLoading"
            >
                <ng-container *ngIf="gridIsEmpty">
                    <agpr-button
                        [id]="id + '.addChartButton_grid'"
                        [style]="buttonTypes.big"
                        icon="fa-regular fa-duotone fa-chart-pie"
                        class="agpr-report-gridAddChartButton"
                        [label]="'Reports.button.addChart' | localize"
                        (click)="addChartClick()"
                    ></agpr-button>
                </ng-container>

                @if(!gridIsEmpty) {
                    <agpr-page-builder (blockMovedByKeyboard)="handleBlockKeyboardMove($event)" (blockResizedByKeyboard)="handleBlockKeyboardResize($event)"></agpr-page-builder>
                }
            </div>
            <agpr-action-bar
                class="agpr-report-footer"
                [headingContext]="'Reports.quickReportDialog.report' | localize"
            >
                <ng-template #left>
                    <agpr-button
                        [id]="id + '.refreshButton'"
                        label="Reports.button.refresh"
                        [loading]="reportsSeriesService.isRefresh"
                        [style]="buttonTypes.secondary"
                        (click)="refreshAll()"
                    ></agpr-button>
                </ng-template>
                <ng-template #right>
                    <agpr-button
                        [id]="id + '.addChartButton'"
                        label="Reports.button.addChart"
                        [style]="buttonTypes.primaryB"
                        (click)="addChartClick()"
                    ></agpr-button>
                    <agpr-button
                        [id]="id + '.createSharedReportButton'"
                        label="Reports.button.generateReport"
                        [disabled]="(globalSeriesState !== seriesStates.loaded) || invalidReportOrBlockId || isDirty"
                        [loading]="globalSeriesState === seriesStates.loading"
                        [tooltip]="generateReportButtonTooltip"
                        [style]="buttonTypes.primaryB"
                        (click)="showSharedReportCreateDialog()"
                    ></agpr-button>
                    <agpr-split-button
                        *ngIf="report.id else newSave"
                        [id]="id + '.saveAsReportButton'"
                        label="Reports.button.save"
                        [style]="buttonTypes.primary"
                        [options]="saveActions"
                        [loading]="saveLoading"
                        panelPositionY="top"
                        panelPositionX="right"
                        [caretDown]="false"
                    ></agpr-split-button>
                    <ng-template #newSave>
                        <agpr-button
                            [id]="id + '.newSaveButton'"
                            label="Reports.button.save"
                            [style]="buttonTypes.primary"
                            [loading]="saveLoading"
                            (click)="processSaveAction()"
                        ></agpr-button>
                    </ng-template>
                </ng-template>
            </agpr-action-bar>
        </section>
        <aside
            class="agpr-report-sidebar"
            [attr.aria-label]="'Common.layout.rhp' | localize"
        >
            <agpr-right-sidebar
                #rightSidebar
                [collapsible]="true"
                [overlayContainer]="overlayContainer"
                [(selectedTabIndex)]="activeSidebarTabIndex"
                [waitForContentInit]="true"
                [contentWidth]="'25rem'"
            >
                <agpr-tab
                    [id]="id + '.detailsTab'"
                    icon=" fa-file-lines"
                    tooltip="Reports.rhp.details"
                    [disabled]="!report || !report.id"
                >
                    <agpr-attribute-list
                        [attributes]="attributes"
                        [id]="id + '.rightSidebar'"
                    >
                    </agpr-attribute-list>
                </agpr-tab>
                <agpr-tab
                    [id]="id + '.settingsTab'"
                    icon=" fa-sliders"
                    tooltip="Reports.sidebar.settingsDetails"
                >
                    <div class="agpr-inputGroup">
                        <div class="agpr-report-sideDetails-dateRangeSelector">
                            <div class="agpr-report-label">
                                {{ 'Reports.sidebar.settings.dateRange.label' | localize}}
                            </div>
                            <agpr-date-query-popup
                                [id]="id"
                                [options]="dateOptions"
                                [(ngModel)]="globalDateQuery"
                                [inputPlaceholder]="'Reports.sidebar.settings.dateRange.various'"
                                [searchRange]="reportHasFolder ? null : searchRange"
                                [dateTypeOptions]="dateTypeOptions"
                                (ngModelChange)="globalDateQueryChange($event)"
                            >
                            </agpr-date-query-popup>
                        </div>
                        <agpr-autocomplete
                            [id]="id + 'reportCurrencyInput'"
                            [suggestions]="suggestions$"
                            [dropdown]="true"
                            label="Reports.sidebar.settings.currency"
                            labelField="label"
                            [(ngModel)]="selectedCurrencyOption"
                            [clearOnBlur]="false"
                            [minLength]="1"
                            (itemSelected)="selectCurrency()"
                        ></agpr-autocomplete>
                    </div>
                    <agpr-form-message
                        *ngIf="fieldErrors.nameLength"
                    >
                        {{ 'Reports.error.maxLengthReached' | localize:{ 'length': 64} }}
                    </agpr-form-message>

                </agpr-tab>
                <agpr-tab
                    [id]="id + '.sourceTab'"
                    icon=" fa-table-tree"
                    tooltip="Reports.sidebar.reportSource"
                >
                    <div>
                        <agpr-panel
                            class="agpr-report-globalSource"
                            header="Reports.sidebar.settings.globalSource.defaultSource.label"
                            [contentPadding]="false"
                            tooltip="Reports.sidebar.settings.globalSource.defaultSource.tooltip"
                            [marginTop]="0"
                        >
                            <div
                                class="agpr-report-globalSource--defaultSource"
                            >
                                <div class="agpr-report-globalSource--seriersPickerContainer">
                                    <agpr-series-picker-field
                                        [id]="id + '_RHP_globalSourcePickerField'"
                                        [field]="globalSingleField"
                                        [(value)]="globalSingleSeries"
                                        [showLabel]="true"
                                        (changes)="singleSeriesChanged($event)"
                                        [showColorSwatch]="true"
                                    >
                                    </agpr-series-picker-field>
                                </div>
                            </div>
                        </agpr-panel>
                        <agpr-panel
                            class="agpr-report-globalSource"
                            header="Reports.sidebar.settings.globalSource.multiSeries.label"
                            [contentPadding]="false"
                            tooltip="Reports.sidebar.settings.globalSource.multiSeries.tooltip"
                        >
                            <div
                                class="agpr-report-globalSource--multiSeries"
                            >
                                <div class="agpr-report-globalSource--seriersPickerContainer">
                                    <agpr-series-picker-compare-field
                                        [id]="id + '_RHP_globalSourceCompareField'"
                                        [field]="globalMultiSeriesField"
                                        [(value)]="globalMultiSeries"
                                        [block]="globalMultiSeriesBlock"
                                        (changes)="multiSeriesChanged($event)"
                                    ></agpr-series-picker-compare-field>
                                </div>
                            </div>
                        </agpr-panel>
                    </div>
                    <ng-template #tabFooter>
                        <agpr-action-bar
                            [headingContext]="'Reports.sidebar.settingsDetails' | localize"
                            headingLevel="4"
                        >
                            <ng-template #right>
                                <agpr-button
                                    [id]="id + '.report.updateSources'"
                                    label="Reports.sidebar.settings.globalSource.applyButton"
                                    [style]="buttonTypes.tertiary"
                                    (click)="updateGlobalSource()"
                                ></agpr-button>
                            </ng-template>
                        </agpr-action-bar>
                    </ng-template>
                </agpr-tab>
            </agpr-right-sidebar>
        </aside>
    </div>
</main>
